import React, { useState } from 'react';
import './SignIn.scss';
import { Link, Redirect, useLocation } from 'react-router-dom';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { signInThunk } from '../../../store/auth/auth-actions';
import { signInSchema } from '../../../helpers/validation';
import { authSelector, isAuthorizedSelector } from '../../../store/auth/auth-selector';
import AppFormInput from '../../../components/ui/forms/controls/AppFormInput';
import { SighInRequest } from '../../../types/auth';
import AppButton from '../../../components/ui/components/Buttons/AppButton/AppButton';
import AuthLayout from '../common/AuthLayout/AuthLayout';
import useInitial from '../../../hooks/useInitial';
import { unwrapResult } from '@reduxjs/toolkit';
import { FormikHelpers } from 'formik/dist/types';
import useQuery from '../../../hooks/useQuery';
import { Trans, useTranslation } from "react-i18next";
import { phoneMask } from "../../../config";

const initialValues = {
    login: '',
    password: '',
};

const SignIn = () => {
    useInitial();
    const [t] = useTranslation();

    let query = useQuery();
    const [showPassword, setShowPassword] = useState(false);

    const isAuthorized = useSelector(isAuthorizedSelector);
    const {isSending} = useSelector(authSelector);
    const dispatch = useDispatch();
    const {pathname, search} = useLocation();

    const handleSubmit = (values: SighInRequest, formikHelpers: FormikHelpers<SighInRequest>) => {
        const {setErrors} = formikHelpers;

        //@ts-ignore
        dispatch(signInThunk(values)).then(unwrapResult)
            .catch(error => {
                setErrors({
                    login: t("Невірний логін чи пароль"),
                    password: t("Невірний логін чи пароль"),
                });
            });
    };

    if (isAuthorized) {
        return <Redirect to={query.get('redirect-url') || '/profile'}/>;
    }

    const rightComponent = () => {
        if(showPassword){
            return <span className="sign-in-show" onClick={()=> setShowPassword(false)} >{t("Приховати")}</span>
        } else {
            return <span className="sign-in-show" onClick={()=> setShowPassword(true)}>{t("Показати")}</span>
        }
    }

    return (
        <AuthLayout
            image="/images/backgrounds/3.jpg"
            activeStep={1}
            className="sign-in"
            title={t("З поверненням")}
            AuthHeader={() => (
                <Trans i18nKey={"Не зареєстровані"}>
                    Не зареєстровані? <Link to={`/auth/signup${query.get('redirect-url') ? `?redirect-url=${query.get('redirect-url')}` : '' }`}>Зареєструйтесь</Link>
                </Trans>
            )}
        >
            <Formik initialValues={initialValues} validationSchema={signInSchema} onSubmit={handleSubmit}>
                <Form>
                    <div>
                        <AppFormInput role="phone" name="login" label={t("Номер вашого телефону")} unmask mask={phoneMask}/>
                        <AppFormInput rightComponent={rightComponent()} type={showPassword ? "text": "password"} name="password" label={t("Пароль")}/>
                        <AppButton theme="primary" className="sign-in__submit" size="middle" showIndicator={isSending}>
                            {t("Увійти")}
                        </AppButton>
                        <Link to="/auth/reset" className="sign-in__remainder-link">
                            <>
                            {t("Забули пароль?")}
                            </>
                        </Link>
                    </div>
                </Form>
            </Formik>
            <div>
                {/*<FormSocialGroup/>*/}

                {/*<div className="sign-in__sign-up-link-mobile">*/}
                {/*   <AuthSignUpLink/>*/}
                {/*</div>*/}
            </div>
        </AuthLayout>
    );
};
export default SignIn;
